// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"66":"textbanner","670":"credits","956":"Debugger"}[chunkId] || chunkId) + "-legacy." + {"66":"7cec67de","520":"dd704f41","670":"3598de53","956":"33d6bf34","962":"a15ce141"}[chunkId] + ".js";
};